import axios from 'axios';
import { REACT_APP_API } from '../../config'

const IDENTIFIER_ENDPOINT_MAP = {
  'transactionalRaw_totals': 'totalByCarlot?withCarlot=true',
  'transactionalRaw_state': 'cardState',
  'transactionalRaw_conversion_rate': 'cardRate'
}

export async function getLeadsDashboardCardData(cardDataIdentifier) {
  const endpoint = IDENTIFIER_ENDPOINT_MAP[cardDataIdentifier]

  const response = await axios.get(`${REACT_APP_API}/indicadores/${endpoint}`)
  return response.data
}
